export const isEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value.trim());

export const normalizeUrl = (value) => {
  const trimmed = value.trim();
  if (!trimmed) return "";
  return /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
};

export const isWebsite = (value) => {
  try {
    const { hostname } = new URL(normalizeUrl(value));
    return /\.[a-z]{2,}$/i.test(hostname);
  } catch {
    return false;
  }
};

export const isPhone = (value) => {
  const digits = value.replace(/\D/g, "");
  return digits.length >= 10 && digits.length <= 15;
};
